import { PaymentISOs } from 'utils/form/constants';

/**
 * Conditionally get the correct payment gateway based on migration and type of payment
 *
 * @param paymentsGateway
 * @param prepaidPaymentsGateway
 * @param migrationPaymentsGateway
 * @param migrationPrepaidPaymentsGateway
 * @param isPayment
 * @param isDigitalWalletMigrationEnabled
 * @returns
 */
export function getGooglePayGateway(
  paymentsGateway: string,
  prepaidPaymentsGateway: string,
  migrationPaymentsGateway: string,
  migrationPrepaidPaymentsGateway: string,
  isPayment: boolean,
  isDigitalWalletMigrationEnabled?: boolean
) {
  // get payment gateway
  const isMigrationPaymentGatewayEnabled =
    isDigitalWalletMigrationEnabled && migrationPaymentsGateway;
  const paymentGateway = isMigrationPaymentGatewayEnabled
    ? migrationPaymentsGateway
    : paymentsGateway;

  // get prepaid gateway
  const isMigrationPrepaidGatewayEnabled =
    isDigitalWalletMigrationEnabled && migrationPrepaidPaymentsGateway;
  const prepaidGateway = isMigrationPrepaidGatewayEnabled
    ? migrationPrepaidPaymentsGateway
    : prepaidPaymentsGateway;

  return isPayment ? paymentGateway : prepaidGateway;
}

export const getGooglePayMerchantId = (
  paymentsMerchantIdMap: { ca: string; us: string },
  migrationPaymentsMerchantIdMap: { ca: string; us: string },
  prepaidPaymentsMerchantIdMap: { ca: string; us: string },
  countryCode: PaymentISOs,
  isPayment: boolean,
  isDigitalWalletMigrationEnabled?: boolean,
  overrideMerchantId?: string
): string => {
  // Getting the gateway merchant id based on the transaction type and the country code of the transaction
  let gatewayMerchantId;
  switch (countryCode) {
    case PaymentISOs.CA:
      if (isPayment) {
        gatewayMerchantId = isDigitalWalletMigrationEnabled
          ? migrationPaymentsMerchantIdMap.ca
          : paymentsMerchantIdMap.ca;
      } else {
        gatewayMerchantId = prepaidPaymentsMerchantIdMap.ca;
      }
      break;
    case PaymentISOs.CH:
    case PaymentISOs.GB:
    case PaymentISOs.US:
      if (isPayment) {
        gatewayMerchantId = paymentsMerchantIdMap.us;
      } else {
        gatewayMerchantId = prepaidPaymentsMerchantIdMap.us;
      }
      break;
    case PaymentISOs.DE:
      if (isPayment) {
        gatewayMerchantId = overrideMerchantId ?? '';
      } else {
        gatewayMerchantId = '';
      }
      break;
    default:
      gatewayMerchantId = '';
  }

  return gatewayMerchantId;
};
